module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EPI"
  }, [_c('span', {
    attrs: {
      "aria-label": "v",
      "id": "pg_v",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("Once I moved about like the wind.")])])]), _vm._v(" "), _c('p', {
    staticClass: "EPS"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OYAAŁÉ")]), _vm._v(" (G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERONIMO")]), _vm._v("), 1886")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 66
// module chunks = 0